export enum SmsTriggerEvent {
  LINE_SIM_ACTIVATION = 'Consumer.HSSInitialAttach',
  LINE_NUMBER_PORTED = 'PhoneNumber.PortInCompleted',
  PLAN_ACTIVATION = 'Plan.PurchaseConfirmation',
  PLAN_QUEUE = 'Plan.Base.PurchaseQueued',
  // Consumed Data = uuid linked to trigger containing usageTrigger.capacityThrehold or usageTrigger.percentCapacityThreshold
  PLAN_CONSUMPTION_REMINDER = 'Plan.UsageNotification',
  // Plan Expiring = uuid linked to trigger containing usageTrigger.timeThreshold or usageTrigger.percentTimeThreshold
  PLAN_TIME_REMINDER = 'UUID',
}
